export enum ReportColumnId {
  SchoolIdShort = "schoolIdShort",
  SchoolName = "schoolName",
  Lms = "lmsName",
  DeploymentId = "deploymentId",
  FirstLaunchAt = "firstLaunchAt",
  LastLaunchAt = "lastLaunchAt",
  UsersCount = "usersCount",
}

interface ReportColumn {
  id: ReportColumnId;
  label: string;
}

export const REPORT_COLUMNS: readonly ReportColumn[] = [
  { id: ReportColumnId.SchoolIdShort, label: "idShort школи" },
  { id: ReportColumnId.SchoolName, label: "Назва школи" },
  { id: ReportColumnId.Lms, label: "LMS" },
  { id: ReportColumnId.DeploymentId, label: "Deployment ID" },
  { id: ReportColumnId.FirstLaunchAt, label: "Дата першого входу" },
  { id: ReportColumnId.LastLaunchAt, label: "Дата останнього входу" },
  { id: ReportColumnId.UsersCount, label: "Кількість користувачів" },
];

export const ROWS_PER_PAGE = 50;

export const CSV_FILE_NAME_BASE = "lms-connections";
export const CSV_EXPORT_URL = "/lms-connections/export";

export const SEARCH_LABEL = "Пошук: idShort, назва або Deployment ID";
export const SEARCH_MIN_CHARS = 2;
export const SEARCH_DEBOUNCE_MS = 1000;

export const PERIOD_LABEL = "Період";
export const ALL_TIME_LABEL = "весь час";
export const SCHOOLS_COUNT_LABEL = "Унікальних шкіл";

export const REPORT_LOAD_ERROR = "Не вдалося завантажити звіт";
export const CSV_DOWNLOAD_ERROR = "Не вдалося сформувати CSV-файл";
export const REPORT_EMPTY = "За обраними фільтрами підключень не знайдено";
